import type { BrandConfig } from '../index'

export const lavmagBrand: BrandConfig = {
  id: "lavmag",
  name: "LAVMAG",
  currency: "PLN",
  freeShippingThreshold: 150,
  siteUrl: "https://lavmag.eu",
  cdnHost: "images.lavmag.eu",
  returnsUrl: "https://wygodnezwroty.pl/lavmag",
  // Moduł odstąpienia istnieje też dla lavmag (zweryfikowane: 200, a nieznany
  // sklep zwraca 404). Hidów integracji WZ dla lavmag jeszcze nie dostaliśmy
  // (poproszeni 2026-07-31) — do tego czasu /zwroty renderuje własny baner
  // zamiast skryptu WZ, a stopka jest bez badge'a. Po otrzymaniu hidów: wpisać
  // `returnsWidget` tutaj albo — bez zmiany kodu — ustawić w deploymencie
  // NUXT_PUBLIC_RETURNS_WZ_BANNER_HID i NUXT_PUBLIC_RETURNS_WZ_WIDGET_HID.
  returnsWithdrawalUrl: "https://wygodnezwroty.pl/lavmag/odstapienie",
  logo: { src: "/brands/lavmag/logo.svg" },
  favicon: {
    svg: "/brands/lavmag/favicon.svg",
    ico: "/brands/lavmag/favicon.ico",
    appleTouchIcon: "/brands/lavmag/apple-touch-icon-180.png",
  },
  footer: {
    address: "Metalurgiczna 11",
    postalCode: "20-234",
    city: "Lublin",
    country: "Polska",
    email: "info@lavmag.eu",
    phone: "661 473 354",
    copyrightName: "LAVMAG",
    createdBy: "contelizer.pl",
    // Bez „sp. z o.o." (zgłoszenie klienta 2026-09-29) — LAVMAG nie jest spółką,
    // regulamin sklepu wskazuje jednoosobową działalność gospodarczą (LAV-MAG).
    legalName: "LAVMAG",
    legalSeat: "Lublinie",
    serviceHours: "8:00 – 15:00",
    links: [
      { label: "Kobieta", href: "/16190-odziez-damska" },
      { label: "Mężczyzna", href: "/16460-odziez-meska" },
      { label: "Dziecko", href: "/18093-dziecko" },
      { label: "Marki", href: "/marki" },
      { label: "Dom i Ogród", href: "/16488-dom-i-ogrod" },
    ],
  },
  social: {
    tiktok: "https://cutt.ly/TT_p",
    instagram: "https://cutt.ly/IG_p",
    facebook: "https://cutt.ly/FB_p",
  },
  seo: {
    titleTemplate: "%s · LAVMAG",
    defaultTitle: "LAVMAG – Moda Less Waste",
    defaultDescription: "Outlet znanych marek do -78% taniej przez cały rok.",
    ogImage: "/brands/lavmag/og-image.png",
    themeColor: "#151515",
  },
  pwa: {
    name: "LAVMAG - Odzież marek premium",
    shortName: "LAVMAG",
    description: "Sklep z odzieżą marek premium",
    icons: [
      { src: "/pwa-icons/icon-192.png", sizes: "192x192", type: "image/png", purpose: "any" },
      { src: "/pwa-icons/icon-512.png", sizes: "512x512", type: "image/png", purpose: "any" },
      { src: "/pwa-icons/icon-maskable-512.png", sizes: "512x512", type: "image/png", purpose: "maskable" },
    ],
    screenshots: [
      { src: "/screenshots/home-mobile.png", sizes: "1080x1920", type: "image/png", form_factor: "narrow" },
      { src: "/screenshots/home-desktop.png", sizes: "1920x1080", type: "image/png", form_factor: "wide" },
    ],
  },
  paymentLogos: [
    { src: "/images/brands/blik.svg", alt: "BLIK", width: 42, height: 20 },
    { src: "/images/brands/przelewy24.svg", alt: "Przelewy24", width: 20, height: 20 },
  ],
  reviews: {
    ekomiCertificateId: "305FC5DF9A03F9B",
    profileUrl: "https://www.ekomi-pl.com/opinie-lavmag.eu.html",
  },
  // Akcja „Im więcej kupujesz, tym więcej zyskujesz" — kody EXTRA. Progi liczone od
  // WARTOŚCI zamówienia (nie od liczby sztuk). Poziomy wg zgłoszenia klienta
  // z 2026-09-17 (Asana 1218578908636126); poprzednie (-20%/200, -25%/250, -30%/320
  // od 2026-07-11) już nie obowiązują.
  //
  // To są TYLKO etykiety — rabat liczy PrestaShop z reguł koszyka, więc te liczby muszą
  // się zgadzać z backendem (StandingPromoPreset::all()['lavmag']) i z treścią belki oraz
  // popupu „TWOJE ZNIŻKI" w BO. Rozjazd = panel obiecuje rabat, którego kupon nie da.
  // Start akcji zostaje datą pierwotną: zmieniają się poziomy, a nie sama akcja.
  // Wysyłka zagraniczna InPost International (Asana 1218980517635240) — baner dla gości
  // z krajów, do których jeżdżą przewoźnicy zagraniczni.
  deliveryCountryBanner: true,
  standingPromo: {
    startsAt: "2026-07-11T00:00:00+02:00",
    accent: { bg: "#fff881", text: "#151515", best: "#e30613" },
    codes: [
      { code: "EXTRA3", pct: "-10%", from: "100 PLN" },
      { code: "EXTRA4", pct: "-15%", from: "150 PLN" },
      { code: "EXTRA5", pct: "-17%", from: "175 PLN" },
      { code: "EXTRA6", pct: "-20%", from: "200 PLN" },
      { code: "EXTRA10", pct: "-24%", from: "250 PLN" },
    ],
  },
  // Zwinięty pasek popupu „TWOJE ZNIŻKI" o wysokości etykiety (Asana 1219036947001658).
  popupCompactTab: true,
  // Sekcja pod hero: nowo dodane sukienki zamiast „Bestsellerów" (prośba lavmaga
  // z 2026-11-03). Zmiana kategorii to edycja tutaj + deploy — klient zmienia ją
  // najwyżej raz na pół roku.
  homeFeaturedCategory: {
    title: "Sukienki",
    id: "16225",
    href: "/odziez-damska/16225-sukienki-wieczorowe",
  },
};
